import type { Resumen } from '../api'
import { fechaCorta, num, usd } from '../formato'

/**
 * Las tres listas de "que hay que mover". Un lead abre la busqueda con su nombre (alli se
 * convierte en cliente, como siempre); un cliente abre su ficha.
 */

interface Props {
  pendientes: Resumen['pendientes']
  alAbrirCliente: (id: string) => void
  alBuscar: (texto: string) => void
}

function Lista<T>({ titulo, vacio, filas, fila }: { titulo: string; vacio: string; filas: T[]; fila: (f: T) => React.ReactNode }) {
  return (
    <div className="tarjeta lista-pendiente">
      <h2>{titulo}</h2>
      {filas.length === 0 ? <p className="suave">{vacio}</p> : <ul>{filas.map(fila)}</ul>}
    </div>
  )
}

export function ResumenPendientes({ pendientes, alAbrirCliente, alBuscar }: Props) {
  return (
    <div className="columnas tres">
      <Lista
        titulo="Leads sin atender"
        vacio="No hay leads sin atender."
        filas={pendientes.leads}
        fila={(l) => (
          <li key={`${l.fuente}-${l.id}`}>
            <button className="enlace" onClick={() => alBuscar(l.nombre)}>
              {l.nombre}
            </button>
            <small className="suave bloque">
              <span className={`insignia insignia-${l.fuente}`}>{l.fuente === 'web' ? 'web' : 'WhatsApp'}</span>{' '}
              {l.consumo_kwh ? `${num(l.consumo_kwh)} kWh/mes · ` : ''}
              {fechaCorta(l.fecha)}
            </small>
          </li>
        )}
      />
      <Lista
        titulo="Clientes sin cotización"
        vacio="No hay clientes sin cotizar."
        filas={pendientes.sin_cotizar}
        fila={(c) => (
          <li key={c.id}>
            <button className="enlace" onClick={() => alAbrirCliente(c.id)}>
              {c.nombre}
            </button>
            <small className="suave bloque">
              {c.categoria} · desde {fechaCorta(c.fecha)}
            </small>
          </li>
        )}
      />
      <Lista
        titulo="Por decidir (las más viejas primero)"
        vacio="No hay cotizaciones pendientes."
        filas={pendientes.por_decidir}
        fila={(p) => (
          <li key={p.cotizacion_id}>
            <button className="enlace" onClick={() => alAbrirCliente(p.cliente_id)}>
              {p.nombre}
            </button>
            <small className="suave bloque">
              v{p.version} · {usd(p.total)} · {fechaCorta(p.fecha)}
            </small>
          </li>
        )}
      />
    </div>
  )
}
